<template>
    <div :style="!$isMobile?themeStyle:themeStyleM" id="app" >
        <template  v-if="!$isMobile">
            <web-header v-if="meta.pageMode === 'paas-page' || meta.pageMode === 'header-nav'"></web-header>
            <div :class="routerClass" :style="pageTopStyle">
                <router-view :key="key"/>
            </div>
            <web-footer v-if="meta.pageMode === 'paas-page'"></web-footer>
        </template>
        <template  v-if="$isMobile">
            <m-header></m-header>
            <div class="m-app-content">
                <router-view :key="key"/>
            </div>
            <m-footer></m-footer>
            <div v-show="appInfo.isShowAppDownload" id="downloadButton_bottom" class="bottom_open_app">在APP中打开</div>
        </template>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { PaasTenant } from '@/models/paas-tenant'
import WebHeader from '@/components/layout/header'
import WebFooter from '@/components/layout/footer.vue'
import MHeader from '@/components/layout/m-header'
import MFooter from '@/components/layout/m-footer'
export default {
    name: "App",
    data() {
      return {
        appInfo: {}
      }
    },
    computed: {
        ...mapState({
            meta: 'meta',
            baseInfo: 'baseInfo'
        }),
        ...mapGetters({
            themeColor: 'themeColor',
            themeColorM: 'themeColorM'
        }),
        themeStyle(){
            return `--theme: ${this.themeColor}`
        },
        themeStyleM(){
            return `--theme: ${this.themeColorM}`
        },
        pageTopStyle(){
            const pageTop = this.baseInfo.layersType === 1 ? '80px' : '150px'
            return `--pageTop: ${pageTop}`
        },
        routerClass(){
            if(this.meta.pageMode === 'paas-page'){
                return 'app-content'
            }else if(this.meta.pageMode === 'header-nav'){
                return 'app-fixed-content'
            }else{
                return ''
            }
        },
        key(){
            return this.$route.path
        }
    },
    components: {
        WebHeader,
        WebFooter,
        /* 移动端 */
        MHeader,
        MFooter,
    },
    mounted() {
      if(this.$isMobile) {
        PaasTenant.getTenantInfo().then(res => {
          this.appInfo = res;
          if(res.isShowAppDownload) {
            new OpenInstall({
              appKey : "oz1r51",
              onready : function() {
                this.schemeWakeup();
                var m = this, button = document.getElementById("downloadButton_bottom");
                button.onclick = function() {
                    m.wakeupOrInstall();
                    return false;
                }
              }
            }, '');
          }
        });
      }
    },
};
</script>

<style>
#app{
    font-size: 14px;
    color: #333;
}
.app-fixed-content {
    height: calc(100vh - var(--pageTop));
    margin-top: var(--pageTop);
    overflow: auto;
}
.app-content{
    margin-top: var(--pageTop);
}
.m-app-content{
    margin-top: 1.29rem;
}
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
.el-dialog {
    width: 30%;
    border-radius: 8px;
}
.home-btn{
    line-height: 40px;
    text-align: center;
    border: 1px solid var(--theme);
    color: var(--theme);
    border-radius: 5px;
    padding: 0 13px;
    cursor: pointer;
}
.home-btn.primary{
    background: var(--theme);
    border-color: var(--theme);
    color: #fff;
}
.home-btn:hover{
    background: var(--theme);
    border-color: var(--theme);
    color: #fff;
}
.home-btn.primary:hover{
    opacity: 0.8;
}
.ql-align-center{
    text-align: center !important;
}
.ql-align-right{
    text-align: right !important;
}
.bottom_open_app{
  position: fixed;
  width: 120px;
  left: 0;
  right: 0;
  margin: 0 auto;
  bottom: 3vh;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  background: #3378f9;
  color: #fff;
  font-size: 13px;
}
.credamo-sms-btn{
    background-color: #F9FAFC;
    color: #7C7C7C;
}
</style>



// WEBPACK FOOTER //
// src/App.vue